import { useContext } from "react";
import { GlobalInitDataContext } from "src/contexts/GlobalInitDataContext";
import { getAppEnvironment } from "src/config/appEnvironment.ts";

export const useShowTestEnvironmentWarning = () => {
	const globalInitData = useContext(GlobalInitDataContext);
	if (globalInitData == null) return false; // Context may not be available in some dialogs etc.
	return (
		globalInitData.environmentType !== "PROD" &&
		// Don't show the warnings on localhost
		getAppEnvironment() !== "dev"
	);
};
